import React from 'react';
import { useTranslation } from 'react-i18next';

import { isFalsy } from 'shared/utils/common';
import ResultOddChip from 'shared/components/outcomes/ResultOddChip';
import { getSportColor, getSportOnColor } from 'shared/utils/sport-colors';
import { vsMarketTypeKey, vsOutcomeTypeKey } from 'lib/virtualSportsI18n';

import { formatEventTimeToHHMM } from 'features/results/formatEventTime';
import ResultCard from './ResultCard';

export default function BaseballResultItems(props: any) {
  const { t } = useTranslation();
  const { current_result = {}, odds_format = 'decimal', market_type_groups, eventId: eventIdProp, eventTimestamp: eventTimestampProp } = props;
  const { odds = [], event_id, event_timestamp } = current_result;

  const eventId = eventIdProp ?? event_id;
  const eventTimestamp = eventTimestampProp ?? event_timestamp;
  const timeStr = formatEventTimeToHHMM(eventTimestamp);
  const headerText = timeStr
    ? `${t('RESULTS_AND_ODDS') || 'Results & Odds'} for event #${String(eventId ?? '')} ${timeStr}`
    : `${t('RESULTS_AND_ODDS') || 'Results & Odds'} for event #${String(eventId ?? '')}`;

  const market_order = [4001, 4002, 4003, 4004];

  const results_list = market_order
    .filter((market_type_id) => !isFalsy((odds as any)?.[market_type_id]?.[(current_result as any)[market_type_id]]))
    .map((market_type_id) => {
      const result = (current_result as any)[market_type_id];
      const odd = (odds as any)?.[market_type_id]?.[result];
      const result_name = result ? t(vsOutcomeTypeKey(String(result), false)) : '';
      const name = t(vsMarketTypeKey(market_type_id, false));
      return (
        <ResultCard key={market_type_id} data-event-results-market={String(market_type_id)}>
          <div className="flex items-center justify-between gap-2 min-h-[3.5rem]">
            <div className="flex-1 min-w-0 flex flex-col justify-center">
              <span className="text-sm font-medium text-foreground">{name}</span>
              <span className="text-sm font-semibold text-foreground">{result_name}</span>
            </div>
            <ResultOddChip odd={odd} oddsFormat={odds_format} />
          </div>
        </ResultCard>
      );
    });

  const sportColor = getSportColor(40);
  const sportOnColor = getSportOnColor(40);

  return (
    <div className="baseball-result-items py-1">
      <div
        className="text-center py-2 rounded-t-lg"
        style={{ backgroundColor: sportColor, color: sportOnColor }}
      >
        <span className="font-bold">{headerText}</span>
      </div>
      <div className="bg-card text-card-foreground border border-border rounded-b-lg p-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {results_list}
        </div>
      </div>
    </div>
  );
}

